import {writable} from 'svelte/store';

let foreignObject = {
    tree: [],
    matches: [],

    selected_id: 0,
    last_selected_id: 0,
    marked_id: 0,

    search_term: '',
};

const {get, set, update, subscribe} = writable(foreignObject);

const foreignGeos = {
    subscribe,
    update,
    set: o => {
        set(foreignObject);
    },
}

export default foreignGeos;